import { bool, node, string } from "prop-types";
import { HtmlParser } from "@utils";
import { Grid } from "@material-ui/core";
import useStyle from "./QuillEditor.style";
import classnames from "classnames";

export const ReadonlyPreview = ({
  value,
  displayValue,
  showDisplayValue,
  children,
  containerClassName,
  blockContentButton,
}) => {
  const classes = useStyle();
  
  const linkBlocker = (e) => {
    if(blockContentButton)
      e.preventDefault();
  }
  
  return (
    <Grid
      item container
      direction="column"
      alignItems="flex-start"
      className={classnames(
        "ql-root",
        showDisplayValue && "ql-ellipsis",
        classes.container, containerClassName
      )}
      onClick={linkBlocker}
    >
      { children }
      <div className={classes.editor}>
        <div className="ql-editor">
          {
            showDisplayValue
              ? HtmlParser(displayValue)
              : HtmlParser(value)
          }
        </div>
      </div>
    </Grid>
  )
}

ReadonlyPreview.propTypes = {
  value: string,
  displayValue: string,
  showDisplayValue: bool,
  children: node,
  containerClassName: string,
  blockContentButton: bool,
}